import { useContext } from 'react';
import { ChatAgentContext } from '../components/ChatAgentContext/ChatAgentContext';

export const useChatAgentContext = () => useContext(ChatAgentContext);
